import type {
  AppSaveBarEventCallbacks,
  AppSaveBarEventType,
} from "./app-save-bar-event.type";
import type { AppSaveBarScope } from "../app-save-bar.enum";

import { useEventBus, useEventBusListener } from "@/modules/event-bus";

import {
  getEventKey,
  getEventPayload,
  isValidScope,
} from "./app-save-bar-event.helper";

export const useAppSaveBarEventEmitter = () => {
  const eventBus = useEventBus();

  const emit = (eventType: AppSaveBarEventType, scope: AppSaveBarScope) => {
    const eventKey = getEventKey(eventType);
    const payload = getEventPayload(scope);
    eventBus.emit(eventKey, payload);
  };

  return {
    emit,
  };
};

export const useAppSaveBarEventListener = (
  scope: AppSaveBarScope,
  { onSave, onCancel }: AppSaveBarEventCallbacks
) => {
  const ON_SAVE_EVENT = getEventKey("save-click");
  const ON_CANCEL_EVENT = getEventKey("cancel-click");

  useEventBusListener(ON_SAVE_EVENT, (payload) => {
    if (isValidScope(payload, scope)) onSave();
  });

  useEventBusListener(ON_CANCEL_EVENT, (payload) => {
    if (isValidScope(payload, scope)) onCancel();
  });
};
